export default {
      id: "video-event_collision-warning-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "img/icons.svg#video-event_collision-warning",
      toString: function () {
        return this.url;
      }
    }